
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialRequestItemsGrid extends Serenity.EntityGrid<MaterialRequestItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialRequestItems'; }
        protected getDialogType() { return MaterialRequestItemsDialog; }
        protected getIdProperty() { return MaterialRequestItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialRequestItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialRequestItemsRow.localTextPrefix; }
        protected getService() { return MaterialRequestItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

    }
}